"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientClaim = void 0;
var ApplicationsClaim_1 = require("./claims/ApplicationsClaim");
var ExternalSystemsClaim_1 = require("./claims/ExternalSystemsClaim");
var ClientClaim = /** @class */ (function () {
    function ClientClaim() {
    }
    ClientClaim.prototype.populate = function (platformClientObject) {
        if (platformClientObject.apps) {
            this.apps = new ApplicationsClaim_1.ApplicationsClaim();
            this.apps.populate(platformClientObject.apps);
            delete platformClientObject.apps;
        }
        if (platformClientObject.ext) {
            this.ext = new ExternalSystemsClaim_1.ExternalSystemsClaim();
            this.ext.populate(platformClientObject.ext);
            delete platformClientObject.ext;
        }
        Object.assign(this, platformClientObject);
    };
    ClientClaim.prototype.getId = function () {
        return this.cid;
    };
    ClientClaim.prototype.getType = function () {
        return this.ctp;
    };
    ClientClaim.prototype.getRoleId = function () {
        return this.rid;
    };
    ClientClaim.prototype.getOfficeId = function () {
        return this.oid;
    };
    ClientClaim.prototype.getBrokerageId = function () {
        return this.bid;
    };
    ClientClaim.prototype.getUserId = function () {
        return this.uid;
    };
    ClientClaim.prototype.getApplications = function () {
        return this.apps;
    };
    ClientClaim.prototype.getExternalSystems = function () {
        return this.ext;
    };
    ClientClaim.prototype.isUserClient = function () {
        return this.ctp === ClientClaim.CLIENT_TYPE_USER;
    };
    ClientClaim.CLIENT_TYPE_USER = "User";
    return ClientClaim;
}());
exports.ClientClaim = ClientClaim;
